let _ = t => t,
  _t;
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { View } from 'foundations-components/components/View';
import { H2 } from 'foundations-components/transitional/components/H2';
import { CardWrapper, CardSection } from 'foundations-components/transitional/components/Card';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { isPrerenderAgent } from '../../../utils/prerender';
import styledWithTheme from 'foundations-theming/utils';
import { getSectionBackgroundStyle } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TranscriptSection = styledWithTheme.section(_t || (_t = _`
  ${0}
`), ({
  theme
}) => getSectionBackgroundStyle(theme.color['fill-surface-raised']));
const PublicPageTranscriptSection = ({
  transcript,
  title,
  contentType
}) => {
  if (!(transcript !== null && transcript !== void 0 && transcript.trim())) return null;
  return /*#__PURE__*/_jsx(TranscriptSection, {
    children: /*#__PURE__*/_jsxs(View, {
      "data-test-id": "public-page-transcript-section",
      paddingBlock: "1100",
      children: [/*#__PURE__*/_jsx(H2, {
        marginBlockEnd: "600",
        textAlign: "center",
        children: contentType === 'LESSON' ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.transcript.lessonTranscript"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.transcript.courseTranscript"
        })
      }), /*#__PURE__*/_jsx(CardWrapper, {
        children: /*#__PURE__*/_jsx(CardSection, {
          paddingBlockEnd: "200",
          children: /*#__PURE__*/_jsx(AccordionItem, {
            defaultOpen: isPrerenderAgent(),
            paddingBlockEnd: "400",
            size: "medium",
            title: title,
            children: /*#__PURE__*/_jsx(View, {
              marginBlockEnd: "400",
              children: /*#__PURE__*/_jsx("div", {
                dangerouslySetInnerHTML: {
                  __html: transcript
                }
              })
            })
          })
        })
      })]
    })
  });
};
export default PublicPageTranscriptSection;